import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./header.css";

import banner1 from "../../assets/banner/armchair-green-living-room-with-copy-space.jpg";
import banner3 from "../../assets/banner/black-sofa-living-room-with-blank-table-mock-up.jpg";
import banner4 from "../../assets/banner/chic-modern-luxury-aesthetics-style-living-room-gray-tone.jpg";
import banner5 from "../../assets/banner/elegant-black-minimal-interior-design.jpg";
import banner6 from "../../assets/banner/empty-modern-room-with-furniture.jpg";
import banner2 from "../../assets/banner/luxury-domestic-kitchen-with-elegant-wooden-design-generated-by-ai.jpg";
import banner7 from "../../assets/banner/pink-sofa-red-living-room-with-copy-space (1).jpg";
import banner8 from "../../assets/banner/pink-sofa-red-living-room-with-copy-space.jpg";
import banner9 from "../../assets/banner/retro-living-room-interior-design.jpg";
import banner10 from "../../assets/banner/sofa-green-living-room-with-copy-space.jpg";
import banner11 from "../../assets/banner/sofa-purple-living-room-with-copy-space.jpg";
import banner12 from "../../assets/banner/wood-sideboard-green-living-room-with-copy-space.jpg";
import banner13 from "../../assets/banner/wood-sideboard-red-living-room-with-copy-space.jpg";


import ReCAPTCHA from "react-google-recaptcha";
import Popupboxx from "../popupboxx/Popupboxx";

function Header() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",


  });

  const [errors, setErrors] = useState({});
  const [responseMessage, setResponseMessage] = useState("");
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [loading, setLoading] = useState(false);



  const handleCaptchaChange = (value) => {
    if (value) {
      setCaptchaVerified(true); // Set to true when CAPTCHA is verified
    } else {
      setCaptchaVerified(false); // Set to false if not verified
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Enter a valid 10-digit phone number";
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }
    if (!captchaVerified) {
      setErrors("Please verify that you are not a robot.");
      return;
    }
    setLoading(true); // Start loading

    try {
      // const response = await fetch("http://localhost:8000/send_email.php", {
      const response = await fetch("https://demo.nspp.in/php/send_email.php", {

        method: "POST",
        headers: {  
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fullName: formData.name,
          email: formData.email,
          phone: formData.phone,

 
        }),
      });

      const result = await response.json();
    

      if (response.ok) {

        setFormData({ name: "", email: "", phone: "", });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      // alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false); // Stop loading
      alert("send successfully")
    }
  };

  return (
    <>
      <header className="header-section">
        <Swiper modules={[Autoplay, Navigation, Pagination]} autoplay={{ delay: 3000, disableOnInteraction: false }} navigation pagination={{ clickable: true }} loop={true} className="banner-swiper">
          <SwiperSlide>
            <div className="banner" style={{ backgroundImage: `url(${banner1})` }}></div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="banner" style={{ backgroundImage: `url(${banner6})` }}></div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="banner" style={{ backgroundImage: `url(${banner3})` }}></div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="banner" style={{ backgroundImage: `url(${banner4})` }}></div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="banner" style={{ backgroundImage: `url(${banner5})` }}></div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="banner" style={{ backgroundImage: `url(${banner2})` }}></div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="banner" style={{ backgroundImage: `url(${banner7})` }}></div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="banner" style={{ backgroundImage: `url(${banner8})` }}></div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="banner" style={{ backgroundImage: `url(${banner9})` }}></div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="banner" style={{ backgroundImage: `url(${banner10})` }}></div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="banner" style={{ backgroundImage: `url(${banner11})` }}></div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="banner" style={{ backgroundImage: `url(${banner12})` }}></div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="banner" style={{ backgroundImage: `url(${banner13})` }}></div>
          </SwiperSlide>
        </Swiper>

        <div className="content-header">
          <h1>Modern Interior Design by First Sky Infra,<br>
          </br><span>Chennai</span></h1>
          {/* <p>First Sky Infra crafts modern interiors that blend elegance,
            smart design, and timeless style—uniquely made for you.</p> */}
          {/* <div className="d-flex align-items-center justify-content-center">
            <button className="download-btn" onClick={() => setIsPopupOpen(true)}>
              Get Details
            </button>
          </div> */}


        </div>

        <div className="enquiry-box">
          <h2>Smart Designs, Smart Prices</h2>
          <p>Get Request</p>
          <form onSubmit={handleSubmit}>
            <input type="text" name="name" placeholder="Your Name" value={formData.name} onChange={handleChange} required />
            {/* {errors.name && <p className="error">{errors.name}</p>} */}

            <input type="email" name="email" placeholder="Your Email" value={formData.email} onChange={handleChange} required />
            {/* {errors.email && <p className="error">{errors.email}</p>} */}

            <input type="tel" name="phone" placeholder="Your Phone" value={formData.phone} onChange={handleChange} required />
            {errors.phone && <p className="error">{errors.phone}</p>}


            <ReCAPTCHA
              sitekey='6LeiptIqAAAAAKT6diIfDS8Wu3vU-4SEIYxA0yB3'
              // sitekey="6LcwRb4qAAAAAMq-olseDFdPgiJ4s48v3oLdfMIW"
              // sitekey="6LdyK74qAAAAAHior1ETtBZRJf6-78AZFgkPYKf3"
              //  // Replace with your reCAPTCHA site key
              onChange={handleCaptchaChange}
            /><br></br>

            <button type="submit" className="header-submit" disabled={loading}>
              {loading ? "Sending..." : "Submit"}
            </button>
          </form>
          {responseMessage && <p className="response-message">{responseMessage}</p>}
        </div>
      </header>

      <Popupboxx
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />


    </>
  );
}

export default Header;
